export const generateUuid = function (): string {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
};

export function hashString(message: string) {
    let hash = 0;
    if (message.length === 0) {
        return hash;
    }
    for (let i = 0; i < message.length; i++) {
        const ch = message.charCodeAt(i);
        hash = (hash << 5) - hash + ch;
        hash &= hash;
    }
    return hash;
}

export function isEmpty(value: any): boolean {
    return value === null || value === undefined || value === "" || value === false;
}
